import React, { useEffect, useState } from "react";
import SaleInvoice from "../pages/sale/SaleInvoice";
import { BusinessSettingsProvider } from "./sidebar/BusinessSettingsContext";

const EVENT = "dukanbuddy:auto-share-invoice";

// Lets the sale form close immediately while the invoice PDF is generated
// and sent in the background by a host mounted at the app root.
export const queueInvoiceAutoShare = (sale) =>
  window.dispatchEvent(new CustomEvent(EVENT, { detail: sale }));

const AutoInvoiceShareHost = () => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const onQueue = (e) => {
      const sale = e.detail;
      if (!sale?.sellUuid) return;
      setJobs((prev) => [...prev, { id: `${sale.sellUuid}-${Date.now()}`, sale }]);
    };
    window.addEventListener(EVENT, onQueue);
    return () => window.removeEventListener(EVENT, onQueue);
  }, []);

  if (!jobs.length) return null;

  return jobs.map(({ id, sale }) => (
    <div
      key={id}
      aria-hidden="true"
      style={{ position: "fixed", left: "-10000px", top: 0, width: "210mm" }}
    >
      <BusinessSettingsProvider businessUuid={sale.bussinessUuid}>
        <SaleInvoice
          item={sale}
          close={() => {}}
          autoShare
          onAutoShareDone={() => setJobs((prev) => prev.filter((j) => j.id !== id))}
        />
      </BusinessSettingsProvider>
    </div>
  ));
};

export default AutoInvoiceShareHost;
